function getDiscountAmount({ offer_amount = 0, order_amount = 0 }) {
  const minPriceAfterDiscount = 1;

  if (offer_amount === 0) return 0;
  if (order_amount >= offer_amount) return 0;

  if (order_amount < minPriceAfterDiscount) {
    return offer_amount - minPriceAfterDiscount;
  }

  return offer_amount - order_amount;
}

export default getDiscountAmount;
